import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { MasterDancing } from '~/Components/Icons/placeholders/MasterDancing';
import ModalComponent from '~/Components/Modal/Modal.component';
import { FONT_SIZE_LARGE } from '~/Constants/UI.constants';
import { useBoolean } from '~/Hooks';
import { Button, Checkbox, Link as MuiLink, Typography } from '~/UIKit';
import { makeStyles } from '~/UIKit/Style';
import cx from 'classnames';

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: 'center',
    padding: '64px 16px',
    [theme.breakpoints.down('md')]: {
      width: '100vw',
      height: '100vh',
    },
  },
  h1: {
    fontSize: FONT_SIZE_LARGE,
  },
  text: {
    lineHeight: theme.spacing(4),
  },
  icon: {
    margin: '20px auto',
    '& .MuiSvgIcon-root': {
      fontSize: 85,
    },
  },
  actionButton: {
    minWidth: 200,
    marginTop: 10,
  },
  closeButton: {
    position: 'absolute',
    top: 10,
    right: 10,
  },
  checkBoxWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
    justifyContent: 'center',
  },
  marginBottom: {
    marginBottom: theme.spacing(3),
  },
  buttonWrapper: {
    marginTop: theme.spacing(3),
  },
}));

export const PartnerWelcomeModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const { state: isTerm, toggle: toggleTerm } = useBoolean(false);
  const { state: isPolicy, toggle: togglePolicy } = useBoolean(false);

  return (
    <ModalComponent onClose={() => {}} open={open}>
      <div className={classes.root}>
        <Typography
          className={classes.h1}
          dangerouslySetInnerHTML={{ __html: t('partner.welcome.headline') }}
        />
        <div className={classes.icon}>
          <MasterDancing />
        </div>
        <Typography
          className={classes.text}
          dangerouslySetInnerHTML={{ __html: t('partner.welcome.message3') }}
        />
        <Typography className={cx(classes.text, classes.marginBottom)}>
          {t('partner.welcome.message2')}
        </Typography>
        <div className={classes.checkBoxWrapper}>
          <Checkbox checked={isTerm} color="primary" onChange={toggleTerm} />
          <Typography>
            <Trans
              i18nKey="partner.termsAndConditions"
              values={{
                agbText: t('subscriptions.AGB'),
              }}
              components={[
                <MuiLink
                  key="terms"
                  href={t('partner.TACLink')}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {t('signup.termsAndConditions')}
                </MuiLink>,
              ]}
            />
          </Typography>
        </div>
        <div className={classes.checkBoxWrapper}>
          <Checkbox checked={isPolicy} color="primary" onChange={togglePolicy} />
          <Typography>
            <Trans
              i18nKey="partner.privacyPolicy"
              values={{
                privacyPolicyText: t('copyright.privacyPolicy'),
              }}
              components={[
                <MuiLink
                  key="privacy"
                  href={t('partner.privacyPolicyLink')}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {t('copyright.privacyPolicy')}
                </MuiLink>,
              ]}
            />
          </Typography>
        </div>
        <div className={classes.buttonWrapper}>
          <Button
            className={classes.actionButton}
            color="primary"
            onClick={onClose}
            variant="contained"
            disabled={!isTerm || !isPolicy}
          >
            {t('onboarding.welcomemessage.button')}
          </Button>
        </div>
      </div>
    </ModalComponent>
  );
};
